import { Components, Model, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { Data } from '@singularsystems/neo-core';
import RunInterceptionComponentVM from '../../../Common/Components/Interception/RunInterceptionComponentVM';
import { AppService, Types } from '../../../App/Services/AppService';
import TransactionInterceptionSearchCriteria from '../Models/Queries/TransactionInterceptionSearchCriteria';
import RawGenericTransactionLookup from '../Models/Lookups/RawGenericTransactionLookup';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import UpdateTransactionComponentVM from '../Components/components/UpdateTransactionComponentVM';
import { TextConstants } from '../../../Common/TextConstants';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import UpdateTransactionCommand from '../Models/Commands/UpdateTransactionCommand';
import TransactionInterceptionCashSearchCriteria from '../Models/Queries/TransactionInterceptionCashSearchCriteria';
import UpdateCashTransactionComponentVM from '../Components/components/UpdateCashTransactionComponentVM';
import UpdateCashTransactionCommand from '../Models/Commands/UpdateCashTransactionCommand';
import TransactionSearchCriteria from '../../../Reports/Transactions/Models/Queries/TransactionSearchCriteria';
import FileDownloadComponentVM from '../../../Common/Components/FileDownload/FileDownloadComponentVM';
import UpdateTransactionModalCommand from '../Models/Commands/UpdateTransactionModalCommand';
import InstrumentSearchLookup from '../../InstrumentMapping/Models/InstrumentSearchLookup';
import ClientLookup from '../../ClientAccountMapping/Models/ClientLookup';
import StaticEventLookup from '../../EventMapping/Models/StaticEventSearchModal/StaticEventLookup';
import { StaticDataTypes } from '../../../Maintenance/StaticData/StaticDataTypes';

@NeoModel
export default class TransactionInterceptionVM extends Views.ViewModelBase {

    constructor(

        public fileDownloadApiClient = AppService.get(Types.ApiClients.FileDownloadApiClient),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public transactionsApiClient = AppService.get(Types.ApiClients.TransactionsApiClient),
        public authorisableUpdateRequestApiClient = AppService.get(Types.ApiClients.AuthorisableUpdateRequestApiClient),
        private serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache)) {
        super(taskRunner);
        this.csvModal = [];
    }

    public transactionsSearchCriteria = new TransactionSearchCriteria();
    public fileDownloadVM = new FileDownloadComponentVM();
    public runInterceptionVM = new RunInterceptionComponentVM();
    public updateTransactionComponentVM = new UpdateTransactionComponentVM();
    public updateCashTransactionComponentVM = new UpdateCashTransactionComponentVM();
    public transactionInterceptionSearchCriteria = new TransactionInterceptionSearchCriteria();
    public transactionInterceptionCashSearchCriteria = new TransactionInterceptionCashSearchCriteria();
    public displayUpdateSecurityTransactionComponent: boolean = false;
    public displayUpdateCashTransactionComponent: boolean = false;
    public displayUpdateTransactionComponent: boolean = false;
    public displayTransactionInterceptionParent: boolean = true;
    public displayCashTransactionComponent: boolean = false;
    public serviceProviderGroupingName: string = "";
    public batchNotes = "";
    public csvSecurityNotes = ""
    public csvCashNotes = ""
    public showAuthModal: boolean = false;
    public showAuthModalCash: boolean = false;
    public showSecurityCSVModal: boolean = false;
    public showCashCSVModal: boolean = false;
    public updateTransactionCommand = new UpdateTransactionCommand();
    public updateCashTransactionCommand = new UpdateCashTransactionCommand();
    public updateTransactionModalCommand = new UpdateTransactionModalCommand();
    public selectedTransactions: RawGenericTransactionLookup[] = [];
    public selectedCashTransactions: RawGenericTransactionLookup[] = [];
    public isAuthorisation: boolean = false;
    public showSecurityTransactions: boolean = true;
    public showCashTransactions: boolean = true;
    public showLoader: boolean = false;
    public csvModal: File[];
    public instruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public filteredInstruments: Model.PlainObject<InstrumentSearchLookup>[] = [];
    public serviceProviderFileGroupings: Model.PlainObject<StaticServiceProviderFileGroupingModel>[] = [];
    public filteredServiceProviderFileGroupings: Model.PlainObject<StaticServiceProviderFileGroupingModel>[] = [];
    public clientAccounts: Model.PlainObject<ClientLookup>[] = [];
    public filteredClientAccounts: Model.PlainObject<ClientLookup>[] = [];
    public events: Model.PlainObject<StaticEventLookup>[] = [];
    public filteredEvents: Model.PlainObject<StaticEventLookup>[] = [];

    public document: Nullable<Document> = null;

    public documentId: number | null = null;
    public fileDescriptorId: number | null = null;

    public pageManagerSecurity = new Data.PageManager(this.transactionInterceptionSearchCriteria, RawGenericTransactionLookup, this.transactionsApiClient.getTransactionInterceptionPagedList, {
        pageSize: 10,
        pageSizeOptions: [10, 20, 50, 100, 250],
        sortAscending: true,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner,
    });

    public pageManagerCash = new Data.PageManager(this.transactionInterceptionSearchCriteria, RawGenericTransactionLookup, this.transactionsApiClient.getCashTransactionInterceptionPagedList, {
        pageSize: 10,
        pageSizeOptions: [10, 20, 50, 100, 250],
        sortAscending: true,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner,
    });

    public async initialise() {
        await Promise.all([
            this.populateCurrencies(),
            this.populateServiceProviderFileGroupings(),
            this.populateClientAccounts(),
            this.populateEvents(),
            this.populateInstruments(),
        ]);
        this.updateTransactionComponentVM.events = this.events;
        this.updateTransactionComponentVM.filteredEvents = this.filteredEvents;
        this.updateTransactionComponentVM.instruments = this.instruments;
        this.updateTransactionComponentVM.filteredInstruments = this.filteredInstruments;
        this.updateCashTransactionComponentVM.events = this.events;
        this.updateCashTransactionComponentVM.filteredEvents = this.filteredEvents;
    }

    public refreshAllCards() {
        if (this.showSecurityTransactions) {
            this.pageManagerSecurity.refreshData();
        }
        if (this.showCashTransactions) {
            this.pageManagerCash.refreshData();
        }
    }

    public showUpdateTransactionComponent() {
        this.displayUpdateTransactionComponent = true;
        this.displayTransactionInterceptionParent = false;
        this.updateTransactionComponentVM.selectedTransactions = this.selectedTransactions;
    }

    public showUpdateCashTransactionComponent() {
        this.displayUpdateCashTransactionComponent = true;
        this.displayTransactionInterceptionParent = false;
        this.updateCashTransactionComponentVM.selectedCashTransactions = this.selectedCashTransactions;
    }

    public showSecurityTransactionsCSVModal() {
        this.showSecurityCSVModal = true;
        this.displayTransactionInterceptionParent = false;
    }

    public showCashTransactionsCSVModal() {
        this.showCashCSVModal = true;
        this.displayTransactionInterceptionParent = false;
    }

    public closeNoteModal() {
        this.showAuthModal = false;
        this.showAuthModalCash = false;
    }

    public closeCSVModal() {
        this.showSecurityCSVModal = false;
        this.showCashCSVModal = false;
        this.csvModal = [];
        this.displayTransactionInterceptionParent = true;
    }

    public saveNote() {
        this.isAuthorisation = true;
        this.showAuthModal = false;
        this.updateTransaction();
    }

    public saveNoteCash() {
        this.isAuthorisation = true;
        this.showAuthModalCash = false;
        this.updateCashTransaction();
    }

    public async backToTransaction() {
        this.displayUpdateTransactionComponent = false;
        this.displayUpdateCashTransactionComponent = false;
        this.displayTransactionInterceptionParent = true;
        this.pageManagerSecurity.refreshData();
        this.selectedTransactions = [];
        this.selectedCashTransactions = [];
        this.updateTransactionCommand = new UpdateTransactionCommand();
        this.updateTransactionComponentVM.updateTransactionCommand = new UpdateTransactionCommand();
        this.updateCashTransactionCommand = new UpdateCashTransactionCommand();
        this.updateCashTransactionComponentVM.updateCashTransactionCommand = new UpdateCashTransactionCommand();
    }

    public async populateCurrencies() {
        this.updateTransactionComponentVM.currencyComponentVM.getCurrenciesList();
    }

    public async populateInstruments() {
        this.instruments = await this.staticDataCache.instruments.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.description!.localeCompare(y.description!)));
        this.filteredInstruments = this.instruments.slice(0, 10);
    }

    public async populateServiceProviderFileGroupings() {
        this.serviceProviderFileGroupings = await this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria()
            .then((arr) => arr.data.sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)));
        this.filteredServiceProviderFileGroupings = this.serviceProviderFileGroupings.slice(0, 10);
    }

    public async populateClientAccounts() {
        this.clientAccounts = await this.staticDataCache.clientAccounts.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.clientDescription.localeCompare(y.clientDescription)));
        this.filteredClientAccounts = this.clientAccounts.slice(0, 10);
    }

    public async populateEvents() {
        this.events = await this.staticDataCache.events.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.staticEventName.localeCompare(y.staticEventName)));
        this.filteredEvents = this.events.slice(0, 10);
    }

    public async confirmTransactionUpdate() {
        this.updateTransactionCommand.updateNotes = "";
    }

    public showUserNotesModal() {
        this.showAuthModal = true;
    }

    public showUserNotesCashModal() {
        this.showAuthModalCash = true;
    }

    public async updateTransaction() {
        let userNotes = this.updateTransactionCommand.updateNotes;
        this.updateTransactionCommand.mapFrom(this.updateTransactionComponentVM.updateTransactionCommand);
        this.updateTransactionCommand.transactions = this.selectedTransactions;
        this.updateTransactionCommand.newStaticCurrencyId = this.updateTransactionComponentVM.currencyComponentVM.selectedCurrency.staticCurrencyId == 0 ? null : this.updateTransactionComponentVM.currencyComponentVM.selectedCurrency.staticCurrencyId;
        this.updateTransactionCommand.staticServiceProviderFileGroupingID = this.transactionInterceptionSearchCriteria.staticServiceProviderFileGroupingID;
        if (this.updateTransactionComponentVM.updateTransactionCommand.meta.newTime.value !== null) {
            this.updateTransactionCommand.newTimeString = this.updateTransactionComponentVM.updateTransactionCommand.meta.newTime.value.toTimeString().substring(0, 8);
        } else {
            this.updateTransactionCommand.newTimeString = null;
        }

        // Manual Validation Required.
        if (this.updateTransactionCommand.newStaticCurrencyId !== null && this.updateTransactionCommand.newStaticCurrencyId > 0 &&
            (this.updateTransactionCommand.updatePriceToBookCostInd == true ||
                (this.updateTransactionCommand.priceOverride !== null && this.updateTransactionCommand.priceOverride > 0))) {
            NotifyUtils.addDanger(TextConstants.Titles.FailedTransactionUpdate, TextConstants.Notifications.UnsuccessfulTransactionUpdate, NotificationDuration.Standard);
        }
        else {
            if (!this.isAuthorisation) {
                this.taskRunner.run(async () => {
                    await this.transactionsApiClient.updateTransactions(this.updateTransactionCommand!.toJSObject())
                    NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SuccessfulTransactionUpdate, NotificationDuration.Standard);
                });
            }
            else {
                this.taskRunner.run(async () => {
                    this.updateTransactionCommand.updateNotes = userNotes;
                    await this.authorisableUpdateRequestApiClient.createAuthorisableUpdateTransactions(this.updateTransactionCommand!.toJSObject())
                    NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
                });
            }

            await this.backToTransaction();
            this.transactionInterceptionSearchCriteria.mapFrom(new TransactionInterceptionSearchCriteria());
            await this.pageManagerSecurity.reset();
        }
    }

    public async updateCashTransaction() {
        let userNotes = this.updateCashTransactionCommand.updateNotes;
        this.updateCashTransactionCommand.mapFrom(this.updateCashTransactionComponentVM.updateCashTransactionCommand);
        this.updateCashTransactionCommand.transactions = this.selectedCashTransactions;
        this.updateCashTransactionCommand.staticServiceProviderFileGroupingID = this.transactionInterceptionSearchCriteria.staticServiceProviderFileGroupingID;

        // Manual Validation Required.
        if (!this.isAuthorisation) {
            this.taskRunner.run(async () => {
                console.log(this.updateTransactionCommand);
                await this.transactionsApiClient.updateCashTransactions(this.updateCashTransactionCommand!.toJSObject())
                NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SuccessfulTransactionUpdate, NotificationDuration.Standard);
            });
        }
        else {
            this.taskRunner.run(async () => {
                this.updateCashTransactionCommand.updateNotes = userNotes;
                await this.authorisableUpdateRequestApiClient.createAuthorisableUpdateCashTransactions(this.updateCashTransactionCommand!.toJSObject())
                NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
            });
        }

        await this.backToTransaction();
        this.transactionInterceptionSearchCriteria.mapFrom(new TransactionInterceptionSearchCriteria());
        await this.pageManagerCash.reset();
    }

    public populateMappedObject(selectedtransactionValues: RawGenericTransactionLookup) {
        var transactionsToUpdate = selectedtransactionValues;
        var existingObject = this.selectedTransactions.find(c => c.rawGenericSecurityTransactionID === transactionsToUpdate.rawGenericSecurityTransactionID);

        if (existingObject) {
            this.selectedTransactions.remove(existingObject)
        }
        else {
            this.selectedTransactions.push(transactionsToUpdate);
        }
    }

    public populateMappedObjectCash(selectedtransactionValues: RawGenericTransactionLookup) {
        var transactionsToUpdate = selectedtransactionValues;
        var existingObject = this.selectedCashTransactions.find(c => c.rawGenericCashTransactionID === transactionsToUpdate.rawGenericCashTransactionID);

        if (existingObject) {
            this.selectedCashTransactions.remove(existingObject)
        }
        else {
            this.selectedCashTransactions.push(transactionsToUpdate);
        }
    }

    public async downloadTransactionsFile() {
        this.serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value ?? "";
        await this.taskRunner.run(async () => {
            this.fileDownloadApiClient.downloadTransactionsFile(this.transactionInterceptionSearchCriteria.toJSObject(), this.serviceProviderGroupingName);
        });
    }

    public async downloadCashTransactionsFile() {
        this.serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value ?? "";
        await this.taskRunner.run(async () => {
            this.fileDownloadApiClient.downloadCashTransactionsFile(this.transactionInterceptionSearchCriteria.toJSObject(), this.serviceProviderGroupingName);
        });
    }

    public async uploadSecurityDocumentFile(fileList: File[] | FileList) {
        if (fileList.length == 0) {
            NotifyUtils.addDanger(TextConstants.Titles.UpdateTransactions, TextConstants.Notifications.UpdateRequestFailed, NotificationDuration.Long);
            return;
        }

        var serviceProviderID = this.transactionInterceptionSearchCriteria.meta.staticServiceProviderFileGroupingID.value;
        var serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value;
        var csvSecurityComment = this.updateTransactionModalCommand.meta.csvSecurityNotes.value;
        var response: any = (await this.taskRunner.run(async () => this.fileDownloadApiClient.uploadSecurityCSV(fileList, serviceProviderID, csvSecurityComment, serviceProviderGroupingName || ""))).data;
        if (response.includes('Success')) {
            NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
        }
        this.closeCSVModal();
    }

    public async uploadCashDocumentFile(fileList: File[] | FileList) {
        if (fileList.length == 0) {
            NotifyUtils.addDanger(TextConstants.Titles.UpdateTransactions, TextConstants.Notifications.UpdateRequestFailed, NotificationDuration.Long);
            return;
        }
        var serviceProviderGroupingName = this.transactionInterceptionSearchCriteria.meta.serviceProviderGroupingName.value;
        var serviceProviderID = this.transactionInterceptionSearchCriteria.meta.staticServiceProviderFileGroupingID.value;
        var csvCashComment = this.updateTransactionModalCommand.meta.csvCashNotes.value;
        var response: any = (await this.taskRunner.run(async () => this.fileDownloadApiClient.uploadCashCSV(fileList, serviceProviderID, csvCashComment, serviceProviderGroupingName || ""))).data;
        if (response.includes('Success')) {
            NotifyUtils.addSuccess(TextConstants.Titles.AuthorisationRequest, TextConstants.Notifications.UpdateRequestCreated, NotificationDuration.Standard);
        }
        this.closeCSVModal();
    }

    public csvModalFileManager = new Components.FileManager({
        multiple: true,
        accept: "csv/*",
        allowedExtensions: [".csv"],
        onFilesSelected: this.onCsvModalSelected.bind(this)
    });

    public onCsvModalSelected(fileList: File[] | FileList) {
        this.csvModal = Array.from(fileList);
    }

}